export default __webpack_public_path__ + "static/media/user-placeholder.a91a38ce.png";